import { DiagnosisSection } from "@/features/patient/clinical-history/components/DiagnosisView";
import { useDiagnoses } from "@/features/patient/clinical-history/utils/adaptClinicalHistory";

export function DiagnosisPage() {
  const { diagnoses, isLoading } = useDiagnoses();
  return <DiagnosisSection diagnoses={diagnoses} isLoading={isLoading} />;
}
